const TRANSACTION_TYPE = {
  CREDIT: 1,
  DEBIT: 2,
  CASHBACK: 3,
};

export default TRANSACTION_TYPE;
